import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="dateFilterContainer" style="height: 400px; width: 420px;z-index: 100000 !important;">
      <VueCtkDateTimePicker
        style="z-index: 100000 !important;"
        range
        inline
        noHeader
        color="#0078c1"
        button-color="#0078c1"
        format="DD.MM.YYYY"
        label="Выберите дату и время"
        button-now-translation="Сейчас"
        v-model="dateRange"
        :custom-shortcuts="shortcuts"
        :no-value-to-custom-elem="false"
        @input="dValueFormatted"
      />
      <div
        class="mb-2 mr-2 ml-2 mt-2"
        style="display: flex; position: absolute; bottom: 0; width: 96%;"
      >
        <b-input
          style="flex: 2;"
          placeholder="Выберите промежуток..."
          :value="showDatetime ? showDatetime : null"
          read-only
          disabled
        >
        </b-input>
        <b-button
          @click="onClear" variant="primary"
          style="flex: 1; margin-left: 5px;"
        >
          Очистить
        </b-button>
      </div>
    </div>
  `,
  data() {
    return {
      dateRange: '',
      drv: '',
      valueGetter: null,
      showFilter: true,
      shortcuts: [
        { key: 'thisWeek', label: 'На этой неделе', value: 'isoWeek' },
        { key: 'lastWeek', label: 'На прошлой неделе', value: '-isoWeek' },
        { key: 'last7Days', label: 'Последние 7 дней', value: 7 },
        { key: 'last30Days', label: 'Последние 30 дней', value: 30 },
        { key: 'thisMonth', label: 'В этом месяце', value: 'month' },
        { key: 'lastMonth', label: 'В прошлом месяце', value: '-month' },
        { key: 'thisYear', label: 'В этом году', value: 'year' },
        { key: 'lastYear', label: 'В прошлом году', value: '-year' }
      ]
    }
  },
  methods: {
    isFilterActive() {
      return this.dateRange !== null && this.dateRange !== undefined && this.dateRange !== ''
    },
    doesFilterPass() {
      return !this.dateRange || this.dateRange
    },
    getModel() {
      return { value: this.dateRange }
    },
    setModel(model) {
      if (model) {
        this.dateRange = model.value
      } else {
        this.dateRange = ''
      }
    },
    onClear() {
      this.dateRange = ''
      this.drv = undefined
    },
    onSbm() {
      this.showFilter = false
    },
    dValueFormatted(val) {
      this.drv = val
    }
  },
  computed: {
    showDatetime() {
      return this.drv && this.drv.start && this.drv.end
        ? `С ${this.drv.start.split(' ')[0]} по ${this.drv.end.split(' ')[0]}`
        : undefined
    }
  },
  watch: {
    dateRange(val, oldVal) {
      if (val !== oldVal) {
        this.params.filterChangedCallback()
      }
    }
  },
  created() {
    this.valueGetter = this.params.valueGetter
    this.field = this.params.colDef.field
  }
})
